import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

import { Servicio } from '../models/servicio';
import { ServicioService } from '../services/servicio.service';
@Component({
  selector: 'app-servicio',
  templateUrl: './servicio.component.html',
  styleUrls: ['./servicio.component.css']
})
export class ServicioComponent implements OnInit {

  model: Servicio = new Servicio();
  url = environment.imgUrl;

  constructor(private modelService: ServicioService, private route: ActivatedRoute) {
    this.model.id = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit() {
    this.modelService.get(this.model.id).subscribe(val => {
      this.model = val;
    });
  }

}
